export default "__VITE_ASSET__gTM3cAue__"